import React from 'react';
import "./App.scss";
import 'bootstrap/dist/css/bootstrap.min.css';
import Main from './components/Main';

const App = () => {
  return (
    <Main />
  );
}

export default App;